import React from "react";
import Icon from "../assets/svg";

const Info = ({ infos }) => (
  <div className="info_container">
    <Icon name="infoSquare" />
    <div className="infos">
      {infos?.map((item, i) => (
        <p key={i}>- {item}</p>
      ))}
    </div>
  </div>
);

export default Info;
